"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isWeworkEnv = exports.isDesktop = void 0;
var _config = _interopRequireDefault(require("./config"));
var isDesktop = /desktop(\/)?/i.test(location.href);
exports.isDesktop = isDesktop;
var isWeworkEnv = _config.default.getConfig('domain') === 'wecom';
exports.isWeworkEnv = isWeworkEnv;